<template>
  <div>
    <div class="popcontent">
      <div class="header_buts">
        <div class="header_but">俱乐部申报</div>
        <div class="header_but">俱乐部查询</div>
      </div>
      <div class="header_title">相关资讯</div>
      <div class="header_subtitle">啦啦操星级俱乐部管理办法（试行）</div>
      <div class="header_subtitle">啦啦操星级俱乐部管理办法（试行）</div>
      <div class="header_subtitle">啦啦操星级俱乐部管理办法（试行）</div>
      <div class="header_title">相关商品</div>
      <div class="goods_item">
        <img src="" class="goods_item_pic" />
        <div class="goods_item_content">
          <div class="goods_item_content_desc">
            训练纯棉T恤（CCA彩钻儿童（CCA彩钻儿童
          </div>
          <div class="goods_item_content_price">12.00</div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "PopContent",
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.popcontent {
  width: 284px;
  min-height: 265px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 10px 7px 0 13px;
}
.header_buts {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  .header_but {
    width: 126px;
    height: 29px;
    line-height: 29px;
    text-align: center;
    background: rgba(50, 197, 255, 0.2);
    border-radius: 8px;

    font-size: 14px;
    font-weight: 400;
    color: #0182e3;
    &:hover{
        cursor: pointer;
        opacity: 0.8;
    }
  }
}
.header_title {
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #444444;
  line-height: 20px;
  margin-top: 11px;
  margin-bottom: 7px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header_subtitle {
  height: 17px;
  max-width: 254px;
  font-size: 12px;
  font-weight: 400;
  color: #444444;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 6px;
  &::before {
    content: "·";
    color: #0091ff;
    font-size: 30px;
    display: inline-block;
  }
  &:hover{
      cursor: pointer;
      font-weight:bold;
  }
}
.goods_item {
  width: 264px;
  height: 60px;
  background: #f8f8f8;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 5px;
  transition: all 0.3s;
  &:hover{
        cursor: pointer;
        transform: scale(1.01);
    }
  img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-right: 7px;
  }
  .goods_item_content {
    flex: 1;
    
    .goods_item_content_desc {
      max-width: 197px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 20px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 10px;
    }
    .goods_item_content_price {
      color: #fa6400;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      &::before{
          content: "￥";
          font-size: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// PopContent.vue?870328b4